var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Insurance',{attrs:{"title":"Secondary","insurance":_vm.secondary,"is_primary":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }